export { default } from "./ContentContainer";
